import { render, staticRenderFns } from "./LocationDescription.vue?vue&type=template&id=33ce9cfc&scoped=true"
import script from "./LocationDescription.vue?vue&type=script&lang=js"
export * from "./LocationDescription.vue?vue&type=script&lang=js"
import style0 from "./LocationDescription.vue?vue&type=style&index=0&id=33ce9cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce9cfc",
  null
  
)

export default component.exports